// @core/api/endpoints/fiscalization/get_fiscal_summary.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetFiscalSummaryResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Get fiscal summary report
 * Returns an aggregated fiscalization summary for the specified period including receipt counts, totals, and failure statistics.
 */
export async function GetFiscalSummary(
  params?: {
  },
  options?: RequestOptions
): Promise<GetFiscalSummaryResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/reports/fiscal-summary`;
  const requestOptions = options;
  return client.get<GetFiscalSummaryResponse>(requestPath, { ...requestOptions, params });
}
